import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "children", "required", "stealthy", "wrapperRef", "onFocus", "onBlur", "onKeyDown", "aria-describedby", "disabled"];
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React, { useState, forwardRef } from 'react';
import styled from 'styled-components';
import AutosizeInput from 'react-input-autosize';
import Box from 'components/Box';
import { textInputStyle, textInputReset, textInputProps } from 'components/TextInput';
var MockInput = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !textInputProps.includes(prop);
  }
}).withConfig({
  displayName: "TagInput__MockInput",
  componentId: "sc-vickv6-0"
})(["", " & input{", " max-width:100%;padding:0;}"], textInputStyle, textInputReset);
var TagInput = /*#__PURE__*/forwardRef(function (props, ref) {
  var id = props.id,
    children = props.children,
    required = props.required,
    stealthy = props.stealthy,
    wrapperRef = props.wrapperRef,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    ariaDescribedBy = props['aria-describedby'],
    disabled = props.disabled,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  function handleFocus(e) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  }
  function handleBlur(e) {
    setIsFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  }
  return /*#__PURE__*/React.createElement(MockInput, {
    ref: wrapperRef,
    isActive: isFocused,
    stealthy: stealthy,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(Box, {
    fillParent: true,
    as: "label",
    htmlFor: id,
    "aria-hidden": "true",
    style: {
      cursor: disabled ? 'not-allowed' : 'text'
    }
  }), /*#__PURE__*/React.createElement(Box, {
    as: "span",
    position: "relative"
  }, children), /*#__PURE__*/React.createElement(AutosizeInput, _extends({}, otherProps, {
    ref: ref,
    id: id,
    required: !!required,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: onKeyDown,
    "aria-describedby": ariaDescribedBy,
    style: {
      maxWidth: '100%'
    },
    autoComplete: "off",
    spellCheck: "false",
    disabled: disabled
  })));
});
TagInput.displayName = 'TagInput';
export default TagInput;